import { createFileRoute } from '@tanstack/react-router';

import { BookCreate } from '@/module/Author/Book/BookCreate';

export const Route = createFileRoute('/_auth/author/_author/book/_book/create')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <BookCreate />;
}
